import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2475420a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Websites die u en uw onderneming een professionele uitstraling geven. Een goede website geeft een gevoel van vertrouwen en kan iemand overhalen tot het ondernemen van actie. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Interessante projecten die momenteel in ontwikkeling zijn. In een later stadium van het ontwikkelingsproces worden dusdanige projecten vrijgegeven in de vorm van een product. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/werkzaamheden" }, "werkzaamheden", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_page_button = _resolveComponent("page-button")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Producten",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Websites",
              path: "/producten/websites"
            }),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Toekomstig",
              path: "/producten/toekomstig"
            }),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" MaatOntwikkeling ontwikkelt ook software op maat. Zie de "),
                _hoisted_4,
                _createTextVNode(" pagina voor meer informatie. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}